module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"search":"Suche","subscriptions":"Mitgliedschaften","products":"Produkte","filterByOffers":"Angebote"},"en":{"search":"Search","subscriptions":"Memberships","products":"Products","filterByOffers":"Offers"}}')
  delete Component.options._Ctor
}
